<template>
    <div id="picture-capture">

        <div class="full-width content-images" v-if="url != null">

            <i class="fa fa-spinner fa-spin delete_loader" style="font-size:24px"
               v-if="picture.deletedInProgress && !displayError"></i>

            <div class="row" v-if="!displayError && url != null">
                <div class="col-xs-12 center">
                    <div class="content-image">
                        <img v-bind:src="absolutePath(picture.filename)" height="auto" width="50%" v-if="picture.id !== null"/>
                        <cropper
                                v-if="picture.id === null"
                                class="cropper"
                                :src="url"
                                :stencil-props="{aspectRatio: 10/10}"
                                v-model="croppedPicture"
                                @change="imageChanged"
                        ></cropper>
                    </div>
                </div>
                <div class="col-xs-12 text-center no-margin-bottom">
                    <button class="btn btn-danger delete-btn " @click="deletePicture() "
                            :disabled="picture.deletedInProgress === true">
                        {{'Upload again'}} <i class="fa fa-trash"></i>
                    </button>
                    <button class="btn btn-primary primary-btn " @click="onUpload() "
                            :disabled="picture.deletedInProgress === true" v-if="picture.id === null">
                        {{'Validate the image'}} <i class="fa fa-crop"></i>
                    </button>
                </div>
            </div>
            <div v-else class="content-image">
                <div class="col-xs-12 error_block">
                    <p>Oops ... Something's wrong...</p>
                </div>
            </div>

        </div>

        <div class="row " v-show="url === null || isUploading">
            <div class="col-xs-12 text-center">

                <input type="file" @change="onFileChanged" class="hidden" v-bind:id="'upload-btn'"
                       accept="image/png,image/jpeg,image/jpg,image/gif" >

                <div id="upload-picture" v-show="isUploading">
                    <strong>{{'Uploading Picture Please Wait'|trans}} </strong>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                             v-bind:style="{width:+uploadPercentage+'%'}"
                        >
                            <span>{{uploadPercentage}}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button  class="btn btn-primary full-width" v-show="!isUploading && url === null" >
            <label v-bind:for="'upload-btn'" class="full-width">
                {{'Take a picture'|trans}}
                <i class="fa fa-camera fa-1x" aria-hidden="true"></i>
            </label>
        </button>

    </div>
</template>

<script>
    import Compressor from 'compressorjs';
    import Spinner from './Spinner';
	import { Cropper } from 'vue-advanced-cropper'


    export default {
        name: 'app',
        props: {
            workerId: Number,
            disableSubmitButton: Boolean
        },
        data() {
            return {
                picture:{
                    id : null,
                    deletedInProgress : false,
                    filename : '',
                    path : ''
                },
				croppedPicture:null,
                uploadPercentage: 0,
                isUploading: false,
                displayError: false,
                url:null
            }
        },
        created() {

        },
        methods: {
            async deletePicture() {
                this.picture.deletedInProgress = true;
                try{
                    await this.$api.worker.deletePictureLogo(this.workerId);
                    this.$emit('enableSubmitButton', true)
					this.$emit('isImageUploaded',false);
                    this.url = null;
					this.picture.deletedInProgress = false;
                } catch(error){
                    this.displayError = true;
                }
            },
            imageChanged({coordinates, canvas}) {
				this.$emit('isImageUploaded',true);
				canvas.toBlob(blob => {
					this.croppedPicture = blob;
                });
			},
            async onUpload() {

                if(!this.croppedPicture){
                    return;
                }
                this.picture.deletedInProgress = false;
                this.displayError = false;
                this.isUploading = true;
                new Compressor(
					this.croppedPicture,
                    {
                        maxWidth: 1200,
                        quality: 85,
                        originalSize: true,
                        scale: 100,
                        success: async compressedFile => {

                            const formData = new FormData();
                            formData.append('file', compressedFile, compressedFile.name);
                            formData.append('worker_logo', compressedFile, compressedFile.name);

                            try{
                                const responseData = await  this.$api.worker.uploadPictureLogo(
                                    this.workerId,
                                    formData,
                                    progressEvent => {
                                        this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                                    }
                                );

                                this.loadingAllImages = false;
                                let fileResponse = responseData;
                                this.picture = {filename: fileResponse.filename, id: fileResponse.filename }
                                this.$emit('enableSubmitButton', false)
                            } catch(error){
                                this.displayError = true;
                                this.picture.filename = '';
                                this.picture.id = '';
                                this.url = null;
                                console.log(error);
                            }

                            this.uploadPercentage = 0;
                            this.isUploading = false;

                        },
                        error(err) {
                            console.log(err.message);
                        }
                    }
                );

				this.$emit('isImageUploaded',true);

            },
            onFileChanged(event) {
            	console.log("changed");
                this.displayError = false;
                this.selectedFile = event.target.files[0];
                this.picture.id = null;
				this.url = URL.createObjectURL(this.selectedFile);
            },
            absolutePath(image) {
                return process.env.VUE_APP_API_BASE_URL_ASSETS + "/media/worker_logo/" + image;
            }
        },
        components: {
            Spinner
        }

    }
</script>

<style scoped>
    .error_block{
        padding: 15px;
        text-align: center;
        padding-bottom: 5px;
        font-weight: bold;
    }
    .center{
        text-align: center;
        margin: auto;
    }
    .center .delete-btn{
        background-color: #ff4b18;
        margin-top: 50px;
        margin-left: 15px;
        vertical-align: middle;
    }
    .content-images{
        /*background: white !important;*/
    }
    #picture-capture .content-image  img{
        border-radius: 50%;
    }
    #picture-capture .content-image {
        overflow: hidden;
        background-color: white;
    }

    #picture-capture .selected-icon {
        position: absolute;
        right: 0px;
        padding: 1px;
        margin: 4px;
        color: white;
        background: #8BC34A;
        border-radius: 8px;
        border: 1px solid #ececec;
    }

    #picture-capture {
        width: 100%;
    }

    #picture-capture ul li {
        display: inline;
        /*padding: 5px;*/
        width: 23%;
        margin:1%;
    }

    #picture-capture ul .image-thumb {
        position: relative;
    }

    #picture-capture ul .delete_loader {
        position: absolute;
        left: 35%;
        top: 14%;
        color: #101010;
        text-shadow: 2px 1px 7px white;
    }

    #picture-capture ul .delete-btn {
        min-height: 30px;
        margin: 0px;
    }

    #picture-capture #upload-photo {
        display: none;
    }

    .flat-blue .progress .progress-bar {
        background-color: #22A7F0;
        border-radius: 9px;
        background-color: #0ae;
        background-image: -webkit-gradient(linear, 0 0, 0 100%, color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.5, transparent), to(transparent));
        background-image: -moz-linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
        background-image: -o-linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
        background-image: linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
    }

    .flat-blue .progress .progress-bar span {
        color: white;
        font-weight: bold;
    }
</style>
